import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'rut',
  standalone: true
})
export class RutPipe implements PipeTransform {
  transform(value: string | null | undefined): string {
    if (!value) return '';
    // Implement RUT formatting logic here

    let rawValue = value.replace(/\./g, '').replace('-', '');
    if(rawValue.length < 2) return rawValue;

    const dv = rawValue.slice(-1);
    let body = rawValue.slice(0, -1);
    body = body.replace(/\B(?=(\d{3})+(?!\d))/g, '.');
    return body + '-' + dv;
  }
}